import * as React from 'react';
import { useStores } from 'utility/hooks';
import { Footer, Header } from '@gc/global-components';
import { FailedRequestMessaging, NoApiResponse } from 'components/shared/error-messages';
import { GlobalNavigationLineOfBusiness } from '__generated__/api';

export const FlightsError = () => {
  const { errorStore, analytics, virtualAgentStore } = useStores();
  const { failedRequestMessaging, serverErrorMessaging, shouldRenderFailedRequestError } = errorStore;
  const { isVirtualAgentClient } = virtualAgentStore;

  analytics.markPageUsable();

  return (
    <>
      {!isVirtualAgentClient && <Header lineOfBusiness={GlobalNavigationLineOfBusiness.FLIGHT} />}
      {shouldRenderFailedRequestError ? (
        <FailedRequestMessaging flightsActionableErrorMessaging={failedRequestMessaging || serverErrorMessaging} />
      ) : (
        <NoApiResponse />
      )}
      {!isVirtualAgentClient && <Footer />}
    </>
  );
};
